import DashboardIcon from '@mui/icons-material/Dashboard';
import BookOnlineIcon from '@mui/icons-material/BookOnline';
import PeopleIcon from '@mui/icons-material/People';
import NotificationsIcon from '@mui/icons-material/Notifications';
import BarChartIcon from '@mui/icons-material/BarChart';
import PaymentIcon from '@mui/icons-material/Payment';
import BuildIcon from '@mui/icons-material/Build';

import { MENU_STRINGS } from './strings';

export interface MenuItemType {
  label: string;
  path: string;
  icon: React.ElementType;
}

export interface MenuGroupType {
  title?: string;
  items: MenuItemType[];
}

export const MENU_GROUPS: MenuGroupType[] = [
  {
    // 🔥 CORE
    items: [
      {
        label: MENU_STRINGS.DASHBOARD,
        path: '/dashboard',
        icon: DashboardIcon,
      },
      {
        label: MENU_STRINGS.BOOKINGS,
        path: '/bookings',
        icon: BookOnlineIcon,
      },
      {
        label: MENU_STRINGS.USERS,
        path: '/users',
        icon: PeopleIcon,
      },
    ],
  },

  {
    title: 'Management', // optional UI label
    items: [
      {
        label: MENU_STRINGS.NOTIFICATIONS,
        path: '/notifications',
        icon: NotificationsIcon,
      },
      {
        label: MENU_STRINGS.REPORTS,
        path: '/reports',
        icon: BarChartIcon,
      },
      {
        label: MENU_STRINGS.PAYMENTS,
        path: '/payments',
        icon: PaymentIcon,
      },

      {
        label: MENU_STRINGS.SERVICES,
        path: '/services',
        icon: BuildIcon,
      },
    ],
  },
];